export type PropsWithLocationId = { id?: string; location?: string };

/**
 * Used to assemble a unique id string from any props object that has an id property. If it also has a location property (with a value), it will combine these
 * @param props - Any object that defines an id prop and optionally a location prop
 * @param suffix - Optional. An additional string that can be appended to id or id and location to make a unique id for a sub-control within a parent component
 * If id is empty or undefined, returns undefined. Otherwise, it returns a string in the form [{location}-]{id}[-{suffix}]
 */
export function dataUniqueId(
  props: PropsWithLocationId,
  suffix?: string
): string | undefined {
  return (
    props.id &&
    `${props.location ? `${props.location}-` : ""}${idWithSuffix(
      props.id,
      suffix
    )}`
  );
}

export function idWithSuffix(id?: string, suffix?: string): string | undefined {
  return id && `${id}${suffix ? `-${suffix}` : ""}`;
}

export function uniqueDropdownId(
  props: PropsWithLocationId,
  controlId: string
): string {
  const unqiueId = dataUniqueId(props) || controlId;
  return unqiueId + "Dropdown";
}
